import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import InfoMessageWithLinks from 'screens/Clients/components/InfoMessageLinksConverter/InfoMessageWithLinks';
import { useNavigate } from 'react-router-dom';

type InformationPopupProps = {
  open: boolean;
  onClose: () => void;
};

const InformationPopup = ({ open, onClose }: InformationPopupProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { padding: '0px 10px 25px 10px' } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 24px',
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {t('mutations.informationDialogPreFillingForms.Title')}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom paddingBottom={2}>
          {t('mutations.informationDialogPreFillingForms.dataSharing')}
        </Typography>
        <Typography variant="h6" gutterBottom>
          {t('mutations.informationDialogPreFillingForms.step1Title')}
        </Typography>
        <Typography variant="body1" gutterBottom>
        <InfoMessageWithLinks
          message={t('mutations.informationDialogPreFillingForms.step1')}
          onInfoClick={() => navigate('/functionaliteit-overzicht')}
          variant="body1"
        />
        </Typography>
        <Typography variant="h6" gutterBottom>
          {t('mutations.informationDialogPreFillingForms.step2Title')}
        </Typography>
        <Typography variant="body1" paddingBottom={2}>
          {t('mutations.informationDialogPreFillingForms.step2')}
        </Typography>
        <Typography variant="body1">
          {t('mutations.informationDialogPreFillingForms.step3')}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default InformationPopup;
